export enum loaderType {
  Spinner1 = 'spinner1',
  Spinner2 = 'spinner2',
  FormSkelton = 'skeltonForm',
  SkeltonCart = 'skeltonCart',
  SkeltonCartSum = 'skeltonCartSum'
}

export interface MediaBannerResponse {
  records: MediaBanner[];
}

export interface MediaBanner {
  id: string;
  category: MediaCategory;
  position: number;
  createdAt: string; // ISO date string
  translation: MediaBannerTranslation;
}
export interface AdminMediaBanner {
  id: string;
  category?: MediaCategory;
  position: number;
  category_id?: string | null;
  createdAt: string; // ISO date string
  translations: MediaBannerTranslation[];
}

export interface MediaBannerTranslation {
  id: string;
  language: string; // e.g. 'en-us', 'ar-ae'
  desktop_image_url: string;
  mobile_image_url: string;
}
export interface MediaCategory {
  id: string;
  parent_category_id: string | null;
  sort_order: number;
  icon_image_url: string;
  gradient_color_1: string;
  gradient_color_2: string;
  use_gradient_colors: boolean;
  show_in_carousel: boolean;
  show_in_home: boolean;
  slug: string;
  cached_product_count: number;
  level: 'main' | 'subcategory' | string;
  createdAt: string;   // ISO date string
  updatedAt: string;   // ISO date string
}